import { createRoot } from 'react-dom/client';
import React from 'react';
import OptionsMenu from './OptionsMenu';
import './OptionsMenu.css';
import { updateConfig } from '../../config.js';

export class UIManager {
    constructor(app) {
        this.app = app;
        this.uiContainer = document.createElement('div');
        this.uiContainer.id = 'game-ui';
        this.uiContainer.style.position = 'absolute';
        this.uiContainer.style.top = '0';
        this.uiContainer.style.left = '0';
        this.uiContainer.style.width = '100%';
        this.uiContainer.style.height = '100%';
        this.uiContainer.style.pointerEvents = 'none'; // Don't block clicks by default
        
        document.body.appendChild(this.uiContainer);
        
        // Create React root
        this.root = createRoot(this.uiContainer);
        
        // Initialize UI state
        this.state = {
            isOptionsVisible: false
        };
        
        // Render initial UI
        this.render();
    }
    
    showOptions() {
        console.log('Showing options menu');
        this.state.isOptionsVisible = true;
        this.uiContainer.style.pointerEvents = 'auto'; // Block clicks when options are visible
        this.render();
    }
    
    hideOptions() {
        console.log('Hiding options menu');
        this.state.isOptionsVisible = false;
        this.uiContainer.style.pointerEvents = 'none'; // Don't block clicks when options are hidden
        this.render();
        // Show main menu when closing options
        if (this.app.menuSystem) {
            this.app.menuSystem.show();
        }
    }
    
    updateConfig(key, value) {
        // Update game config directly
        updateConfig(key, value);
        
        // Also emit event for other systems
        if (this.app.stage) {
            this.app.stage.emit('configUpdate', { key, value });
        }
    }
    
    render() {
        console.log('Rendering UI, options visible:', this.state.isOptionsVisible);
        this.root.render(
            this.state.isOptionsVisible ? 
                React.createElement(OptionsMenu, {
                    onClose: () => this.hideOptions(),
                    onUpdateConfig: (key, value) => this.updateConfig(key, value)
                }) : 
                null
        );
    }
    
    destroy() {
        this.root.unmount();
        document.body.removeChild(this.uiContainer);
    }
} 